import { get } from 'lodash'
import { connect } from 'react-redux'

import { auth, common } from '../../../../constants/actions'
import withRecaptcha from '../../../../hoc/withRecaptcha'
import { getPaymentProviders } from '../../../../selectors'
import LogIn from './component'

export const mapStateToProps = state => ({
  eventLogo: get(state, 'formSettings.eventLogo'),
  landingPageLogo: get(state, 'formSettings.landingPageLogo'),
  formType: get(state, 'formSettings.formType'),
  guestRegistration: get(state, 'formSettings.guestRegistration'),
  isSubmitPending: get(state, 'common.showLoadingIndicator'),
  loginMsg: get(state, 'auth.loginError.message'),
  getLoginErrorType: get(state, 'auth.loginError.type'),
  successMsg: get(state, 'auth.loginMsg.message'),
  paymentProviders: getPaymentProviders(state),
  systemAlert: get(state, 'common.systemAlert'),
  orgLogo: get(state, 'formSettings.orgLogo'),
})
export default connect(mapStateToProps, {
  signin: auth.signin,
  setLoginError: auth.setLoginError,
  resendVerificationEmail: auth.resendVerificationEmail,
  resetForm: auth.signout,
  getSystemAlert: common.getSystemAlert,
})(withRecaptcha('Login')(LogIn))
